import BigButton from "components/atoms/buttons/BigButton";
import { useCallback, useState } from "react";
import DeactivateModal from "./DeactivateModal";

export interface DeactiveButtonFunc {
  onClick: () => void;
  disabled?: boolean;
}

export type Props = {
  title: React.ReactNode | string;
  subTitle: string;
  onDeactive: () => void;
  disabled?: boolean;
  buttonLabel?: string;
  button?: React.ComponentType<DeactiveButtonFunc>;
  onClickBefore?: () => Promise<void>;
  onCancel?: () => void;
  "data-testid"?: string;
};

export default function DeactivateButton({
  title,
  subTitle,
  onDeactive,
  disabled,
  buttonLabel = "Delete",
  button: ButtonElement,
  onClickBefore,
  onCancel,
  "data-testid": dataTestId,
}: Props): JSX.Element {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const onOpenModal = useCallback(async () => {
    await onClickBefore?.();
    setIsShowModal(true);
  }, [onClickBefore]);
  return (
    <>
      {isShowModal && (
        <DeactivateModal
          title={title}
          subTitle={subTitle}
          onDeactive={onDeactive}
          disabled={disabled}
          onCancel={onCancel}
          setIsShowModal={setIsShowModal}
        />
      )}

      {ButtonElement ? (
        <ButtonElement
          onClick={onOpenModal}
          disabled={disabled}
          data-testid={
            dataTestId ?? "blocks-modal-deactivate-button-element-open-modal"
          }
        />
      ) : (
        <BigButton
          label={buttonLabel}
          buttonType="warning"
          onClickBtn={onOpenModal}
          disabled={disabled}
          data-testid={
            dataTestId ?? "blocks-modal-deactivate-button-open-modal"
          }
        />
      )}
    </>
  );
}
